export const getQuery = (queryKey) => {
  const searchParams = window.location.search;
  const params = new URLSearchParams(searchParams);
  return (params.get(queryKey) || "").toLowerCase();
};
